// extracted by mini-css-extract-plugin
export var ousterBlogRelatedPosts = "index-module--ousterBlogRelatedPosts--lWUOD";
export var ousterBlogRelatedPostsContainer = "index-module--ousterBlogRelatedPostsContainer--afc3m";